module.exports = __webpack_public_path__ + "img/question_icon.0941a2ce.png";